import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendApiService } from 'src/app/shared/services/backend-api.service';
import { TurnstileService } from 'src/app/shared/services/turnstile.service';
import { TurnstileComponent } from 'src/app/shared/components/turnstile/turnstile.component';
import { NotEmptyInputValidator } from 'src/app/shared/validators/is-not-empty.validator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-demo-request',
  templateUrl: './demo-request.component.html',
  styleUrls: ['./demo-request.component.scss'],
})
export class DemoRequestComponent implements OnInit {
  @ViewChild('turnstileWidget') turnstileWidget!: TurnstileComponent;

  form!: FormGroup;
  isLoading: boolean = false;
  demoRequestSuccess: boolean = false;
  isFormReady = false;
  turnstileToken: string | null = null;
  siteKey = environment.turnstileSiteKey;

  constructor(
    private fb: FormBuilder,
    private backendApiService: BackendApiService,
    private turnstileService: TurnstileService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.email, new NotEmptyInputValidator()],
      ],
    });

    this.form.statusChanges.subscribe(
      (e) => (this.isFormReady = 'INVALID' != e)
    );
  }

  onTurnstileToken(token: string | null): void {
    this.turnstileToken = token;
    this.turnstileService.setToken(token);
  }

  onSubmit() {
    if (this.form.invalid || !this.turnstileToken) return;

    this.isLoading = true;
    this.backendApiService
      .sendDemoRequest(this.form.controls['email'].value)
      .subscribe({
        next: (result: any) => {
          this.demoRequestSuccess = true;
          this.turnstileService.clearToken();
          this.turnstileToken = null;
        },
        error: (err: any) => {
          console.log(err);
          if (err.status === 400 || err.status === 403) {
            this.turnstileWidget?.reset();
            this.turnstileService.clearToken();
            this.turnstileToken = null;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  isControlInvalid(controlName: string) {
    var control = this.form.controls[controlName];

    return control.touched && control.dirty && control.invalid;
  }
}
